module.exports = __webpack_public_path__ + "img/id.54528617.svg";